module.exports = __webpack_public_path__ + "static/img/banner.7e4f4de.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/researchCamp/banner.png
// module id = XwJj
// module chunks = 1